<template>
  <chart-container
    :titleChart="titleChart"
    @onCSVDownload="downloadCsv(titleChart)"
    @zoomEnabled="zoomGraph(true)"
    @zoomDisabled="zoomGraph(false)"
    :downloadId="downloadId"
    :specificSiteId="specificSiteId"
    :zoomGraphValue="zoomGraphValue"
    :downloadShow="(dataSource.categories && Object.keys(dataSource.categories).length > 0) || (series2Ddatasources.data && Object.keys(series2Ddatasources.data).length > 0)"
  >
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs>
        <b-tab v-for="(tabName, index) in tabList" :key="index" :title="tabName" @click="tabChange(tabName)" />
      </b-tabs>
    </span>
    <div v-if="choosenTab === 'Total'" slot="body" class="flex-display">
      <div class="p-0 sub-mw-100">
        <fusioncharts style="width: 100%;" type="column2d" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="series2Ddatasources" dataEmptyMessage="No Data In" ref="engagementChart" v-if="series2Ddatasources.data && Object.keys(series2Ddatasources.data).length > 0" />
      </div>
      <div class="p-0 mw-100" v-if="series2Ddatasources.data && Object.keys(series2Ddatasources.data).length > 0">
        <ul style="list-style:none; padding-left: 0px;font-family:RobotoRegular; font-size: 10px; color: #666669; position: absolute;top: 50%;transform: translate(0, -50%);">
          <li v-for="(item, index) in series2d" :key="index">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" style="margin-right:5px;" viewBox="0 0 456.008 560.035">
              <path :fill="item.color" :d="getSvgIcon(item.label)" />
            </svg>
            <span style="padding-bottom: 8px;display: inline-block;vertical-align: middle;">{{ item.label }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div slot="body" v-else-if="choosenTab !== 'Total'">
      <fusioncharts style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="engagementChart" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0" />
    </div>
    <div v-if="series2Ddatasources.data.length === 0 && dataSource.categories.length === 0" class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>
<script>
import _cloneDeep from "lodash/cloneDeep";
import { downloadCSV, getSiteID } from "../../services/visualization/data-management";
import ChartContainer from "./chart-container.vue";
import moment from "moment";
import _ from "lodash";
import { TOTALDEVICE, PARTICIPANTSTATUS, COUNTRIES, SITES } from "@/constants/config";
import * as se from "@/services/visualization/study-engagement";

export default {
  components: {
    ChartContainer
  },
  props: {
    zoomGraphValue: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    filterTriggered: { type: Boolean, default: false },
    sitesSelected: [Array, String],
    countrySelected: [Array, String],
    engagementRaw: { default: null },
    specificSiteId: [Object, Array],
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      downloadId: "average-duration-by-device",
      tabList: [TOTALDEVICE, PARTICIPANTSTATUS, COUNTRIES, SITES],
      xAxisName: TOTALDEVICE,
      type: "scrollColumn2d",
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: se.dataSources,
      series2Ddatasources: se.series2dOptions,
      zoomGraphValueChild: "",
      curZoomLevel: 0,
      maxZoomLevel: 3,
      maxColumn: 0,
      todayDate: "",
      tDateShow: true,
      series: {},
      series2d: [],
      getSiteID,
      colorLegendIosPhone: "black",
      colorLegendIosTablet: "black",
      colorLegendAndroidPhone: "black",
      colorLegendAndroidTablet: "black",
      choosenTab: TOTALDEVICE
    };
  },

  watch: {
    specificSiteId: function() {
      if (this.specificSiteId.length > 0) {
        this.tabList = [TOTALDEVICE, PARTICIPANTSTATUS, COUNTRIES];
      }
    },
    filterTriggered: function() {
      const { series, series2d } = se.GET_ACTIVITY_DEVICE_SERIES(this.engagementRaw, this.countrySelected, this.sitesSelected, this.xAxisName);
      this.series = series;
      this.series2d = series2d;
    },
    engagementRaw: function(newValue) {
      const { series, series2d } = se.GET_ACTIVITY_DEVICE_SERIES(newValue, this.countrySelected, this.sitesSelected, this.xAxisName);
      this.series = series;
      this.series2d = series2d;
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    series2d: function(value) {
      if (value.length !== 0) {
        const getFilterColorIosPhone = _.filter(value, { label: "IOS Phone" });
        const getFilterColorIosTablet = _.filter(value, {
          label: "IOS Tablet"
        });
        const getFilterColorAndroidPhone = _.filter(value, {
          label: "Android Phone"
        });
        const getFilterColorAndroidTablet = _.filter(value, {
          label: "Android Tablet"
        });

        this.colorLegendIosPhone = getFilterColorIosPhone.length !== 0 && getFilterColorIosPhone[0].color;
        this.colorLegendIosTablet = getFilterColorIosTablet.length !== 0 && getFilterColorIosTablet[0].color;
        this.colorLegendAndroidPhone = getFilterColorAndroidPhone.length !== 0 && getFilterColorAndroidPhone[0].color;
        this.colorLegendAndroidTablet = getFilterColorAndroidTablet.length !== 0 && getFilterColorAndroidTablet[0].color;
      }

      this.series2Ddatasources.data = value;
    },

    series: function(newValue) {
      if (newValue && newValue.categories) {
        const { categories, dataset } = newValue;
        const datasources = _cloneDeep(se.dataSources);

        if (categories && categories.length != 0 && categories[0].category.length > 0) {
          datasources.categories = [...categories];
          datasources.dataset = dataset;
          this.maxColumn = categories[0].category.length;
        }

        datasources.chart.numvisibleplot = 0;
        datasources.chart.xaxisname = this.xAxisName;
        datasources.chart.maxLabelHeight = this.xAxisName === "Participant Status" ? "20" : "30";

        this.dataSource = datasources;
      } else {
        const datasources = { categories: null };
        this.dataSource = datasources;
      }
    }
  },

  mounted() {
    if (this.series.categories) {
      const datasources = _cloneDeep(se.dataSources);
      const { categories, dataset } = this.series;

      if (categories && categories.length != 0 && categories[0].category.length > 0) {
        datasources.categories = [...categories];
        datasources.dataset = dataset;
        this.maxColumn = categories[0].category.length;
      }

      datasources.chart.numvisibleplot = 0;
      datasources.chart.xaxisname = this.xAxisName;

      this.dataSource = datasources;
    }
  },
  methods: {
    tabChange(tabName) {
      this.xAxisName = tabName;
      this.choosenTab = tabName;
      const { series, series2d } = se.GET_ACTIVITY_DEVICE_SERIES(this.engagementRaw, this.countrySelected, this.sitesSelected, this.xAxisName);

      this.series = series;
      this.series2d = series2d;
    },
    getSvgIcon(deviceName) {
      let icon = null;
      if (deviceName.toLowerCase().includes("android")) {
        icon =
          "m76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969s-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266v-142.914c0-9.309-3.323-17.283-9.97-23.929s-14.627-9.969-23.935-9.969zm275.198-128.294 23.598-43.532c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zm-231.654 292.639c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924v-221.361h-305.09zm352.304-227.663c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266v-142.914c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z";
      } else if (deviceName.toLowerCase().includes("ios")) {
        icon =
          "M380.844 297.529c.787 84.752 74.349 112.955 75.164 113.314-.622 1.988-11.754 40.191-38.756 79.652-23.343 34.117-47.568 68.107-85.731 68.811-37.499.691-49.557-22.236-92.429-22.236-42.859 0-56.256 21.533-91.753 22.928-36.837 1.395-64.889-36.891-88.424-70.883-48.093-69.53-84.846-196.475-35.496-282.165 24.516-42.554 68.328-69.501 115.882-70.192 36.173-.69 70.315 24.336 92.429 24.336 22.1 0 63.59-30.096 107.208-25.676 18.26.76 69.517 7.376 102.429 55.552-2.652 1.644-61.159 35.704-60.523 106.559M310.369 89.418C329.926 65.745 343.089 32.79 339.498 0 311.308 1.133 277.22 18.785 257 42.445c-18.121 20.952-33.991 54.487-29.709 86.628 31.421 2.431 63.52-15.967 83.078-39.655";
      }
      return icon;
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }

      setTimeout(() => {
        this.tabChange(this.xAxisName);
      }, 1);
    },
    downloadCsv(titleChart) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        const header = ["Total"];
        const headerTotal = ["Device", "Total"];
        const newArr = [];
        this.tDateShow = true;

        if (this.choosenTab === TOTALDEVICE && this.series2Ddatasources.data && Object.keys(this.series2Ddatasources.data).length > 0) {
          this.series2Ddatasources.data.map((item, i) => {
            newArr.push([item.label + " (Minutes)"]);
            newArr[i].splice(2, 0, item.value);
          });

          downloadCSV(titleChart, headerTotal, newArr, this.specificSiteId);
        } else if (this.choosenTab !== TOTALDEVICE && this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0) {
          this.dataSource.categories[0].category.map(row => {
            newArr.push([row.label]);
          });
          this.dataSource.dataset.forEach(d => {
            header.push(d.seriesname + " (Minutes)");
            d.data.map((row, i) => {
              newArr[i].splice(2, 0, row.value ? row.value : 0);
            });
          });

          header[0] = this.xAxisName;
          downloadCSV(titleChart, header, newArr, this.specificSiteId);
        }
      }, 1);
    }
  }
};
</script>
<style scoped>
.sub-mw-100 {
  width: calc(100% - 100px);
}

.flex-display {
  display: flex;
}
</style>
